/* eslint-disable @nx/enforce-module-boundaries */
import { Stack } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import Head from 'next/head';
import { forwardRef } from 'react';
import { JobsListingLayout } from 'v4/snippets/jobs/layout';
import { SearchJobsListing } from 'v4/snippets/jobs/search-listing';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
const JobsSearchPage = forwardRef(({ ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <AuthenticatedProviders>
      <JobsListingLayout>
        <Stack spacing={4}>
          <Head>
            <title>
            {t('otherModules.job_description') || "Job search engine , Search & Apply for Jobs"}
            </title>
            <meta
              name="og:title"
              content="Search & Apply for Jobs | Elevate Your Career with us!"
            />
            <meta
              name="description"
              content="Discover your next career move! Browse our job listings, search for the perfect opportunity, and apply in a click. Take the next step towards your professional success."
            />
            <meta
              name="keywords"
              content="Job Website USA, Professional Job Website USA, Job portals in usa, Best job posting sites, Best job search sites, 10 Top Job Posting Site In India In 2023, Top job search engines, Recruiting sites, Best Job Search Websites"
            />
            <meta
              name="og:description"
              content="Discover your next career move! Browse our job listings, search for the perfect opportunity, and apply in a click. Take the next step towards your professional success."
            />
            <link
              rel="canonical"
              href={`${typeof window !== 'undefined' && window.location.href}`}
            />
          </Head>
          <SearchJobsListing />
        </Stack>
      </JobsListingLayout>
    </AuthenticatedProviders>
  );
});

export default JobsSearchPage;
